import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Event } from "../models/event.model";

export namespace EventActions {
    
  @logDispatcher
  export class GetEvents {
    static readonly type = '[Event] GetEvents';
    constructor() {}
  }
  
  @logDispatcher
  export class GetEventsSuccess {
    static readonly type = '[Event] GetEventsSuccess';
    constructor(public events: Event[]) {}
  }
  
  @logDispatcher
  export class Error {
    static readonly type = '[Event] Error';
    constructor(public error: any) {}
  }
}
